// src/components/CatylexSearch/CatylexDateBadge.tsx
// Calendar-style date badge (year over a dark month/day box) shared by result cards.

import * as React from "react";
import { parseAgreementDate } from "./catylexFormatters";
import { catylexColors } from "./catylexSearchStyles";

interface CatylexDateBadgeProps {
  /** ISO 8601 agreement date; the badge renders nothing when absent/invalid. */
  isoDate?: string;
}

const badgeStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  width: "38px",
  flexShrink: 0,
  borderRadius: "4px",
  overflow: "hidden",
  border: `1px solid ${catylexColors.border}`,
  textAlign: "center",
};

const yearStyle: React.CSSProperties = {
  fontSize: "9px",
  fontWeight: 600,
  color: "#ffffff",
  backgroundColor: catylexColors.foreground,
  padding: "1px 0",
  lineHeight: 1.4,
};

const boxStyle: React.CSSProperties = {
  backgroundColor: "#ffffff",
  color: catylexColors.foreground,
  padding: "2px 0 3px",
};

const monthStyle: React.CSSProperties = {
  fontSize: "9px",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  lineHeight: 1.3,
};

const dayStyle: React.CSSProperties = {
  fontSize: "14px",
  fontWeight: 700,
  lineHeight: 1.1,
};

const CatylexDateBadge: React.FC<CatylexDateBadgeProps> = ({ isoDate }) => {
  const parts = parseAgreementDate(isoDate);
  if (!parts) return null;

  return (
    <div style={badgeStyle} aria-label={`Dated ${parts.month} ${parts.day}, ${parts.year}`}>
      <div style={yearStyle}>{parts.year}</div>
      <div style={boxStyle}>
        <div style={monthStyle}>{parts.month}</div>
        <div style={dayStyle}>{parts.day}</div>
      </div>
    </div>
  );
};

export default CatylexDateBadge;
